module.exports = __webpack_public_path__ + "img/Row3.98caada4.png";